import { RenderContainer } from "../RenderContainer";
import React, { useEffect, useState } from "react";
import { Renderer, Renderer2, RendererProps } from "../model";
import { ErrorM } from "components/helpers/FormHelpers/ErrorM";
import { useField } from "formik";

const CustomFloat: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
}) => {
  const [{ value }] = useField(field.name);
  return (
    <RenderContainer
      customFieldName={customField.name}
      classWrapper={classWrapper}
      orderNumber={customField.orderNumber}
    >
      <React.Fragment>
        {handleOnChange && (
          <>
            <input
              className={`EditBox${readOnly ? " ViewOnly" : ""} ${
                classWrapper ? classWrapper : ""
              }`}
              value={
                readOnly
                  ? value[index].value && typeof value[index].value === "string"
                    ? value[index].value
                    : "-"
                  : value[index].value && typeof value[index].value === "string"
                  ? value[index].value
                  : undefined
              }
              type={readOnly ? "text" : "number"}
              step="any"
              readOnly={readOnly}
              onChange={e => handleOnChange(e, index)}
            />
            <ErrorM name={customField.name} />
          </>
        )}
      </React.Fragment>
    </RenderContainer>
  );
};

export const customFloat: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField
) => (
  <CustomFloat
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
    isMulti={isMulti}
    classWrapper={classWrapper}
    booleanField={booleanField}
  />
);
